import { action, computed, makeAutoObservable } from "mobx";
import type {
  PartFamilyRow,
  SummaryFamilyRow,
  ProfileFamilyRow,
} from "../../pages/family-grouping/types/family-grouping.types";

export class FamilyGrpStore {
  familyGropudata: PartFamilyRow[] = [];
  familySummaryData: SummaryFamilyRow[] = [];
  familyProfileData: ProfileFamilyRow[] = [];
  isLoadingPart = false;
  isLoadingSummary = false;
  isLoadingProfile = false;
  error: string | null = null;

  constructor(rootStore: any) {
    makeAutoObservable(this);
  }

  @action
  setfamilygrpdata(value: PartFamilyRow[]) {
    this.familyGropudata = value;
    this.error = null;
  }

  @action
  setFamilySummaryData(value: SummaryFamilyRow[]) {
    this.familySummaryData = value;
    this.error = null;
  }

  @action
  setFamilyProfileData(value: ProfileFamilyRow[]) {
    this.familyProfileData = value;
    this.error = null;
  }

  @action
  setLoadingPart(loading: boolean) {
    this.isLoadingPart = loading;
  }

  @action
  setLoadingSummary(loading: boolean) {
    this.isLoadingSummary = loading;
  }

  @action
  setLoadingProfile(loading: boolean) {
    this.isLoadingProfile = loading;
  }

  @action
  setError(error: string | null) {
    this.error = error;
  }

  @action
  clearAllData() {
    this.familyGropudata = [];
    this.familySummaryData = [];
    this.familyProfileData = [];
    this.error = null;
  }

  @computed
  get totalFamilies(): number {
    return this.familyGropudata.reduce(
      (sum, part) => sum + parseInt(part.families || "0", 10),
      0
    );
  }

  @computed
  get totalVoters(): number {
    return this.familyGropudata.reduce((sum, part) => sum + (part.total || 0), 0);
  }

  @computed
  get selectedBoothFamilyCount(): number {
    return this.familySummaryData.length;
  }

  @computed
  get selectedFamilyMemberCount(): number {
    return this.familyProfileData.length;
  }
}
